import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { ChevronDown, LibraryBig } from "lucide-react";
import { CATALOG } from "./catalog";

/**
 * Slide-out drawer with the report catalog.
 * Trigger is a compact button showing the currently active report + a chevron.
 */
export default function ReportCatalogSheet({ active, activeKey, open, onOpenChange, onPick }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <button
          data-testid="rep-picker"
          className="group inline-flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-md border border-slate-200 hover:border-slate-400 hover:bg-slate-50 transition-colors"
        >
          <div className="h-7 w-7 rounded bg-red-50 border border-red-100 flex items-center justify-center">
            <active.icon className="h-3.5 w-3.5 text-red-600" strokeWidth={2} />
          </div>
          <div className="text-left leading-tight">
            <div className="text-[10px] tracking-wider uppercase text-slate-400 -mb-0.5">Report</div>
            <div className="text-[13px] font-semibold text-slate-900">{active.title}</div>
          </div>
          <ChevronDown className="h-3.5 w-3.5 text-slate-400 ml-1 group-hover:text-slate-700" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[340px] p-0 flex flex-col" aria-describedby={undefined}>
        <SheetHeader className="p-4 border-b border-slate-200">
          <SheetTitle className="text-[14px] flex items-center gap-2">
            <LibraryBig className="h-4 w-4 text-red-600" /> Report Catalog
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-2 thin-scroll">
          {CATALOG.map((group) => (
            <div key={group.label} className="mb-3">
              <div className="px-2 pt-2 pb-1 text-[10px] tracking-[0.16em] uppercase font-semibold text-slate-400">
                {group.label}
              </div>
              <div className="space-y-0.5">
                {group.items.map((r) => (
                  <button
                    key={r.key}
                    onClick={() => onPick(r.key)}
                    data-testid={`report-${r.key}`}
                    className={`w-full flex items-start gap-2.5 text-left px-2.5 py-2 rounded-md transition-colors ${
                      activeKey === r.key
                        ? "bg-red-50 border border-red-200"
                        : "border border-transparent hover:bg-slate-50"
                    }`}
                  >
                    <r.icon className={`h-4 w-4 mt-0.5 shrink-0 ${activeKey === r.key ? "text-red-600" : "text-slate-400"}`} strokeWidth={1.75} />
                    <div className="min-w-0 flex-1">
                      <div className={`text-[13px] font-medium truncate ${activeKey === r.key ? "text-slate-900" : "text-slate-700"}`}>
                        {r.title}
                      </div>
                      <div className="text-[11px] text-slate-500 leading-snug mt-0.5 line-clamp-2">{r.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
